export const USER_CONFIG = {
  MIN_NAME_LENGTH: 3,
  MAX_NAME_LENGTH: 50,
  PHONE_REGEX: /^[6-9]{1}[0-9]{9}$/,
  NAME_REGEX: /^[a-zA-Z\s]+$/,
  INVALID_NAME: 'Please enter valid name',
  NAME_TOO_LONG: 'Name entered is too long (max 50 char)',
  NAME_SPECIAL_CHARS: 'Please enter a valid name (no numbers or symbols)',
  INVALID_MOBILE: 'Invalid Phone number',
  EMPTY_MOBILE: 'Phone number cannot be empty',
  INVALID_EMAIL: 'Invalid Email ID',
};
